/* Home page mockup carousel — arrow controls as progressive enhancement.
 *
 * The track scrolls natively, so the carousel is fully usable with no JavaScript. The
 * arrows stay hidden until this script runs, so they can never render as dead controls.
 * They are also hidden when everything already fits on screen, and disabled at each end
 * rather than wrapping around, which would lose the reader's place.
 */
(function () {
  'use strict';

  function setupCarousel(section) {
    var track = section.querySelector('[data-carousel-track]');
    var controls = section.querySelector('[data-carousel-controls]');
    if (!track || !controls) return;

    var prev = controls.querySelector('[data-carousel-prev]');
    var next = controls.querySelector('[data-carousel-next]');
    if (!prev || !next) return;

    function overflows() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function syncState() {
      if (!overflows()) {
        controls.hidden = true;
        return;
      }
      controls.hidden = false;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    // Scroll by whole cards so a card never ends up half cut off.
    function step(direction) {
      var firstItem = track.querySelector('.mockup-carousel__item');
      var cardWidth = firstItem ? firstItem.getBoundingClientRect().width + 18 : 280;
      var perPage = Math.max(1, Math.floor(track.clientWidth / cardWidth));
      track.scrollBy({ left: direction * cardWidth * perPage, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', syncState, { passive: true });
    window.addEventListener('resize', syncState);

    syncState();
  }

  function init() {
    var sections = document.querySelectorAll('.mockup-carousel');
    for (var i = 0; i < sections.length; i++) setupCarousel(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

